var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47.47A.75.75 0 013.75 1v8a.75.75 0 11-1.5 0V2.81l-.72.72A.75.75 0 11.47 2.47l2-2zm7.703-.211a1.75 1.75 0 011.577 1.74v2A1.75 1.75 0 0110 5.75H8a.25.25 0 00-.25.25v2a.25.25 0 00.25.25h3a.75.75 0 010 1.5H8A1.75 1.75 0 016.25 8V6A1.75 1.75 0 018 4.25h2a.25.25 0 00.25-.25V2a.25.25 0 00-.25-.25H7a.75.75 0 010-1.5h3l.173.01zM17.5.249a2.25 2.25 0 012.25 2.25v1c0 .557-.208 1.09-.577 1.5.369.412.577.945.577 1.5v1a2.25 2.25 0 01-2.25 2.25H15a.75.75 0 010-1.5h2.5l.147-.014a.75.75 0 00.603-.735v-1a.75.75 0 00-.603-.736L17.5 5.75H16a.75.75 0 010-1.5h1.5l.147-.015a.75.75 0 00.603-.735v-1a.75.75 0 00-.603-.736L17.5 1.75H15a.75.75 0 010-1.5h2.5z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.7bceaecb7595810fb49a3449f6b2b260.svg";
export { ForwardRef as ReactComponent };